interface Props {
  color: string;
}

const CampaignsIcon = ({ color }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 496 512">
      <path
        fill={color}
        d="M475.1,180.3c-12.2-12.2-28.4-19-45.5-19h-8.1V32.1c0-5.5-2.4-11.1-6.6-15.3c-4.3-4.4-10.1-6.9-15.9-6.9
	c-0.8,0-1.6,0.1-2.4,0.2l0,0l0,0c-2.7,0.4-5.2,1.2-7.6,2.5L163.8,131.1H24.2c-0.3,0-0.7,0-1,0c-0.4,0-0.8,0-1.2,0l-0.1,0l-0.1,0
	C11,132.2,1.9,142.3,1.9,153.2l0,145.2c0,11.8,10.3,22.1,22.1,22.1h44.6l55.5,166.4c2.9,8.8,11.7,15.2,21,15.2h84.7
	c6.7,0,13.2-3.6,17.5-9.6c4.3-6,5.6-13.4,3.4-19.7l-43-129.3L389,439.1c3.1,1.6,6.7,2.5,10.3,2.5c4.1,0,8.1-1.1,11.4-3.1
	c6.5-3.9,10.7-11.4,10.7-19V290.3h8.1c17.1,0,33.3-6.7,45.5-19c12.2-12.2,19-28.4,19-45.5S487.3,192.5,475.1,180.3z M449.8,225.8
	c0,11.5-8.7,20.2-20.2,20.2h-8.1v-40.5h8.1C441.1,205.5,449.8,214.3,449.8,225.8z M161,457.9l-45.8-137.3h38.2l45.8,137.3H161z
	 M147.2,175.3v101h-101v-101H147.2z M377.2,68.8v314.1l-185.8-97.8V166.5L377.2,68.8z"
      />
    </svg>
  );
};

export default CampaignsIcon;
